import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { tabButton, tabList, tabPanel } from './tabsStyles';
function Tabs({ tabsLabel, tabElement, tabs, onTabChange, }) {
    const TabControllerElement = tabElement;
    return (_jsxs("div", { children: [_jsx("div", { css: tabList, role: "tablist", "aria-label": tabsLabel, children: tabs.map((tab) => {
                    const selected = tab.selected ? 'true' : 'false';
                    return (_jsx(TabControllerElement, { css: tabButton, role: "tab", id: tab.id, href: tab.href, "aria-selected": selected, "aria-controls": `${tab.id}-tab`, onClick: (event) => {
                            event.preventDefault();
                            onTabChange(tab.id);
                        }, children: tab.text }));
                }) }), tabs.map((tab) => (_jsx("div", { css: tabPanel, role: "tabpanel", id: `${tab.id}-tab`, "aria-labelledby": tab.id, hidden: !tab.selected, children: tab.content })))] }));
}
export default Tabs;
